/**
 * @generated SignedSource<<08247c0e3353f502c6ab48ec21242ef6>>
 * @relayHash 0ca6fbc81dc6db0a2b75e5e31688f8f2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7b02565943ba78281f88347582fa278755748b9ab1ccdcdbaf5300a1ad8b36d1

import type { ConcreteRequest } from 'relay-runtime';
export type useFetchAvailableSourcesQuery$variables = {
  cloudId: string;
  spaceKey: string;
};
export type useFetchAvailableSourcesQuery$data = {
  readonly confluence_remoteObjectAvailableSources: ReadonlyArray<string | null> | null;
};
export type useFetchAvailableSourcesQuery = {
  response: useFetchAvailableSourcesQuery$data;
  variables: useFetchAvailableSourcesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "kind": "ScalarField",
    "name": "confluence_remoteObjectAvailableSources"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useFetchAvailableSourcesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFetchAvailableSourcesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0ca6fbc81dc6db0a2b75e5e31688f8f2",
    "id": "7b02565943ba78281f88347582fa278755748b9ab1ccdcdbaf5300a1ad8b36d1",
    "metadata": {},
    "name": "useFetchAvailableSourcesQuery",
    "operationKind": "query",
    "text": "query useFetchAvailableSourcesQuery($cloudId:ID!,$spaceKey:String!){confluence_remoteObjectAvailableSources(cloudId:$cloudId,spaceKey:$spaceKey)}"
  }
};
})();

(node as any).hash = "965970e949d0f5bb2e85206332f80ad9";

export default node;
